/* BABY IN WOOD — simulateur « Le voir sur mon mur » (fenêtre de la fiche produit). Script commun mis en cache par le navigateur ; chaque instance s'initialise via window.biwSimQ.push(id). */
(function(){
  "use strict";
  function init(SID){
  var openBtn=document.getElementById('biwSimOpen-'+SID);
  var modal=document.getElementById('biwSim-'+SID);
  if(!openBtn||!modal||modal.dataset.init) return;
  modal.dataset.init='1';
  /* PERFORMANCE : tout le simulateur ne s'initialise qu'au premier clic sur « Le voir sur mon mur » */
  var api=null;
  openBtn.addEventListener('click',function(){ if(!api){ api=init()||{open:function(){}}; } api.open(); });
  function init(){
  var KEY='biw_wall_v1', MAX_SIDE=1400, TTL=30*864e5;
  function track(name,data){
    try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:'biw_sim_'+name, sim:'produit'},data||{})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('biw:sim',{detail:{name:name,where:'produit',data:data||{}}})); }catch(e){}
  }

  var stage=document.getElementById('biwStage-'+SID);
  var wall=stage.querySelector('.biw-sim__wall');
  var dec=stage.querySelector('.biw-sim__dec');
  var cal=stage.querySelector('.biw-sim__cal');
  var line=stage.querySelector('.biw-sim__line');
  var ptA=stage.querySelector('[data-p="a"]');
  var ptB=stage.querySelector('[data-p="b"]');
  var len=stage.querySelector('.biw-sim__len');
  var hint=stage.querySelector('.biw-sim__hint');
  var file=modal.querySelector('input[type=file]');
  var barCal=modal.querySelector('[data-bar="calib"]');
  var barRes=modal.querySelector('[data-bar="result"]');
  var cmIn=modal.querySelector('.biw-sim__cm input');
  var loupe=stage.querySelector('.biw-sim__loupe');
  var fileC=modal.querySelector('input[data-role="camera"]');
  var memoEl=modal.querySelector('.biw-sim__memo');
  var shareBtn=modal.querySelector('[data-act="share"]');
  var rot=0, rotIn=modal.querySelector('[data-act="rot"]'), rot0=modal.querySelector('[data-act="rot0"]');
  function applyRot(){ dec.style.transform='translate(-50%,-50%) rotate('+rot+'deg)'; }
  if(rotIn) rotIn.addEventListener('input',function(){ rot=parseFloat(rotIn.value)||0; applyRot(); });
  if(rotIn) rotIn.addEventListener('change',function(){ track('rotate',{deg:rot}); });
  if(rot0) rot0.addEventListener('click',function(){ rot=0; if(rotIn) rotIn.value=0; applyRot(); });

  var DEC_H=parseFloat(modal.dataset.h)||85;      /* hauteur réelle du décor (cm), décor droit */
  var DEC_W=parseFloat(modal.dataset.w)||0;       /* largeur réelle (cm), décor droit */
  var DEC_BH=DEC_H;                                /* hauteur réellement occupée au mur (visuel incliné compris) */
  /* Analyse d'un visuel détouré : boîte opaque + orientation (moments d'inertie de la partie opaque).
     → {W,H : px naturels ; x,y,w,h : boîte en fractions 0..1 ; phi : angle de l'axe principal (° depuis l'horizontale,
        sens horaire à l'écran) ; elong : allongement (1 = rond, grand = fin et long)} ou null. */
  function biwDecorFit(im){
    try{
      if(!im||!im.naturalWidth||!im.naturalHeight) return null;
      var W=im.naturalWidth, H=im.naturalHeight, S=260, sc=Math.min(1,S/Math.max(W,H));
      var c=document.createElement('canvas'); c.width=Math.max(1,Math.round(W*sc)); c.height=Math.max(1,Math.round(H*sc));
      var cx=c.getContext('2d'); cx.drawImage(im,0,0,c.width,c.height);
      var d=cx.getImageData(0,0,c.width,c.height).data, w=c.width, h=c.height;
      var x0=w,y0=h,x1=-1,y1=-1,n=0,sx=0,sy=0,sxx=0,syy=0,sxy=0;
      for(var y=0;y<h;y++){ for(var x=0;x<w;x++){ var i=(y*w+x)*4; if(d[i+3]>16 && !(d[i]>245&&d[i+1]>245&&d[i+2]>245)){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; n++; sx+=x; sy+=y; sxx+=x*x; syy+=y*y; sxy+=x*y; } } }
      if(x1<0||n<20) return null;
      var mx=sx/n, my=sy/n, uxx=sxx/n-mx*mx, uyy=syy/n-my*my, uxy=sxy/n-mx*my;
      var phi=0.5*Math.atan2(2*uxy, uxx-uyy)*180/Math.PI;
      var tr=(uxx+uyy)/2, dt=Math.sqrt(Math.max(0,((uxx-uyy)/2)*((uxx-uyy)/2)+uxy*uxy));
      return {W:W,H:H,x:x0/w,y:y0/h,w:(x1-x0+1)/w,h:(y1-y0+1)/h,phi:phi,elong:(tr+dt)/Math.max(1e-6,tr-dt)};
    }catch(e){ return null; }
  }
  /* Encombrement au mur d'un décor dont les cotes (Wcm × Hcm) sont données DROITES alors que le visuel peut être incliné
     (ex. la fusée photographiée en biais). → {bw, bh : largeur/hauteur réellement occupées (cm) ; deg : inclinaison}.
     Un visuel droit, ou pas assez allongé pour trancher, garde exactement les cotes déclarées. */
  function biwFootprint(Wcm, Hcm, fit){
    var r={bw:Wcm||0, bh:Hcm||0, deg:0};
    if(!fit||!(Wcm>0)||!(Hcm>0)) return r;
    var deg=fit.phi-((Hcm>=Wcm)?90:0); while(deg>90) deg-=180; while(deg<=-90) deg+=180;
    if(fit.elong<1.8||Math.abs(deg)<8) return r;
    /* un visuel DROIT a le même rapport largeur/hauteur que les cotes déclarées (le marchand mesure la boîte du décor) :
       on ne conclut à une inclinaison que si le rapport mesuré s'en écarte d'au moins 1,5× (fusée : 3,6×) */
    var rm=(fit.w*fit.W)/(fit.h*fit.H), qd=rm/(Wcm/Hcm);
    if(qd<1.5&&qd>0.6667) return r;
    var t=deg*Math.PI/180, c=Math.abs(Math.cos(t)), s=Math.abs(Math.sin(t));
    var bw=Wcm*c+Hcm*s, bh=Wcm*s+Hcm*c, rp=bw/bh;
    if(rp/rm>1.35||rm/rp>1.35) return r;
    return {bw:bw, bh:bh, deg:deg};
  }
  var A={x:26,y:16}, B={x:26,y:84};               /* points de calibrage (% du stage) */
  var decHimg=0;                                  /* hauteur du décor en px NATURELS de l'image */
  var imgPxPerCm=0;

  /* ---------- mémorisation locale partagée avec la page « Voir sur mon mur » ---------- */
  function loadSaved(){
    try{ var j=JSON.parse(localStorage.getItem(KEY)||'null'); if(!j||!j.img||!(j.ppc>0)) return null;
      if(Date.now()-(j.ts||0)>TTL){ localStorage.removeItem(KEY); return null; } return j; }catch(e){ return null; }
  }
  function saveWall(){
    try{ if(!wall.src||wall.src.indexOf('data:')!==0||!(imgPxPerCm>0)) return;
      localStorage.setItem(KEY, JSON.stringify({img:wall.src, ppc:imgPxPerCm, ts:Date.now()})); if(memoEl) memoEl.hidden=false; }catch(e){}
  }
  function forgetWall(){
    try{ localStorage.removeItem(KEY); }catch(e){}
    imgPxPerCm=0; decHimg=0; wall.removeAttribute('src'); loupe.style.backgroundImage='';
    stage.classList.remove('has','placed','real','calib'); barCal.hidden=true; barRes.hidden=true;
    if(memoEl) memoEl.hidden=true; track('forget');
  }
  function downscale(dataUrl, cb){
    var im=new Image();
    im.onload=function(){
      var w=im.naturalWidth,h=im.naturalHeight,s=Math.min(1,MAX_SIDE/Math.max(w,h));
      if(s>=1 && dataUrl.length<2.5e6){ cb(dataUrl); return; }
      try{ var c=document.createElement('canvas'); c.width=Math.round(w*s); c.height=Math.round(h*s);
        c.getContext('2d').drawImage(im,0,0,c.width,c.height); cb(c.toDataURL('image/jpeg',.85)); }catch(e){ cb(dataUrl); }
    };
    im.onerror=function(){ cb(dataUrl); };
    im.src=dataUrl;
  }

  /* PART de la hauteur de l'image occupée par le décor (le reste = marge transparente). */
  var decFillH=1;
  function measureDec(){
    var b=biwDecorFit(dec); if(!b||b.h<0.2){ decFillH=1; DEC_BH=DEC_H; return; }
    decFillH=b.h; DEC_BH=biwFootprint(DEC_W,DEC_H,b).bh;
    if(stage.classList.contains('placed')) applyDecScale();
  }
  if(dec.complete && dec.naturalWidth) measureDec(); else dec.addEventListener('load', measureDec);

  function containScale(){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih) return 0;
    var r=stage.getBoundingClientRect();
    return Math.min(r.width/iw, r.height/ih);
  }
  function applyDecScale(){
    var cs=containScale(), hh=DEC_BH*imgPxPerCm; if(!hh||!cs) return;
    dec.style.height=Math.max(24, hh*cs/decFillH)+'px'; dec.style.width='auto';
  }

  /* verrouillage TOTAL du scroll de la page (iOS compris) */
  var _lockY = 0;
  function lockScroll(){
    _lockY = window.scrollY || 0;
    document.body.style.position = 'fixed'; document.body.style.top = (-_lockY) + 'px';
    document.body.style.left = '0'; document.body.style.right = '0'; document.body.style.width = '100%'; document.body.style.overflow = 'hidden';
  }
  function unlockScroll(){
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = '';
    document.body.style.width = ''; document.body.style.overflow = ''; window.scrollTo(0, _lockY);
  }
  function open(){
    /* le decor est en chargement differe (il ne pese rien tant que la fenetre est fermee) : on le reclame ici */
    if(dec && dec.getAttribute("loading") === "lazy"){ dec.setAttribute("loading", "eager"); if(dec.complete && dec.naturalWidth) measureDec(); }
    if(modal.parentNode!==document.body){ document.body.appendChild(modal); }
    modal.hidden=false; lockScroll(); track('open');
    if(!stage.classList.contains('has')){ var s=loadSaved(); if(s) restore(s); }
  }
  function close(){ modal.hidden=true; unlockScroll(); }
  modal.querySelector('.biw-sim__x').addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!modal.hidden) close(); });

  /* ---------- étapes ---------- */
  function toCalib(){
    stage.classList.add('calib'); stage.classList.remove('placed','real');
    barCal.hidden=false; barRes.hidden=true;
    hint.textContent='Faites glisser les 2 points le long de l’objet';
    drawLine();
  }
  function toResult(){
    stage.classList.remove('calib'); stage.classList.add('placed','real');
    barCal.hidden=true; barRes.hidden=false;
    hint.textContent='Faites glisser le décor pour le positionner';
    hint.classList.remove('fade'); clearTimeout(hint._t);
    hint._t = setTimeout(function(){ hint.classList.add('fade'); }, 3500);
  }

  /* ---------- 1. photo (galerie OU appareil), réduite avant usage ---------- */
  function useWall(dataUrl, then){
    wall.onload=function(){ stage.classList.add('has'); loupe.style.backgroundImage="url('"+dataUrl+"')"; then(); };
    wall.src=dataUrl;
  }
  function restore(s){
    useWall(s.img, function(){
      imgPxPerCm=s.ppc; decHimg=DEC_H*imgPxPerCm;
      dec.style.left='50%'; dec.style.top='50%';
      toResult(); applyDecScale(); if(memoEl) memoEl.hidden=false; track('restored');
    });
  }
  function loadWall(input){
    var f=input.files&&input.files[0]; input.value='';
    if(!f) return;
    var r=new FileReader();
    r.onload=function(e){ downscale(e.target.result, function(small){ useWall(small, function(){ A={x:26,y:16}; B={x:26,y:84}; imgPxPerCm=0; toCalib(); track('photo'); }); }); };
    r.readAsDataURL(f);
  }
  file.addEventListener('change',function(){ loadWall(file); });
  fileC.addEventListener('change',function(){ loadWall(fileC); });
  modal.querySelectorAll('[data-act="pick"]').forEach(function(b){ b.addEventListener('click',function(e){ e.stopPropagation(); file.click(); }); });
  modal.querySelectorAll('[data-act="camera"]').forEach(function(b){ b.addEventListener('click',function(e){ e.stopPropagation(); fileC.click(); }); });
  if(!(window.matchMedia && window.matchMedia('(pointer:coarse)').matches)){
    modal.querySelectorAll('[data-act="camera"]').forEach(function(b){ b.style.display='none'; });
  }
  modal.querySelectorAll('[data-act="forget"]').forEach(function(b){ b.addEventListener('click', forgetWall); });

  /* ---------- 2. calage ---------- */
  function drawLine(){
    ptA.style.left=A.x+'%'; ptA.style.top=A.y+'%';
    ptB.style.left=B.x+'%'; ptB.style.top=B.y+'%';
    var r=stage.getBoundingClientRect();
    var ax=A.x/100*r.width, ay=A.y/100*r.height, bx=B.x/100*r.width, by=B.y/100*r.height;
    var dx=bx-ax, dy=by-ay, L=Math.hypot(dx,dy);
    line.style.left=ax+'px'; line.style.top=ay+'px'; line.style.width=L+'px';
    line.style.transform='rotate('+(Math.atan2(dy,dx)*180/Math.PI)+'deg)';
    len.style.left=((A.x+B.x)/2)+'%'; len.style.top=((A.y+B.y)/2)+'%';
    len.textContent=(cmIn.value||'?')+' cm';
    return L;
  }
  var LP=(window.innerWidth<=600)?100:132, ZOOM=2.2;
  loupe.style.width=LP+'px'; loupe.style.height=LP+'px';
  function showLoupe(pt){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih) return;
    var r=stage.getBoundingClientRect();
    var px=pt.x/100*r.width, py=pt.y/100*r.height;
    var scale=Math.min(r.width/iw, r.height/ih);
    var rw=iw*scale, rh=ih*scale, ox=(r.width-rw)/2, oy=(r.height-rh)/2;
    var ix=px-ox, iy=py-oy;
    loupe.style.backgroundSize=(rw*ZOOM)+'px '+(rh*ZOOM)+'px';
    loupe.style.backgroundPosition=(-(ix*ZOOM-LP/2))+'px '+(-(iy*ZOOM-LP/2))+'px';
    var lx=Math.max(6,Math.min(r.width-LP-6,px-LP/2));
    var ly=py-LP-20; if(ly<6){ ly=py+20; }
    loupe.style.left=lx+'px'; loupe.style.top=ly+'px';
    loupe.classList.add('on');
  }
  function hideLoupe(){ loupe.classList.remove('on'); }
  var grabbed=null;
  cal.addEventListener('pointerdown',function(e){
    var r=stage.getBoundingClientRect();
    var x=(e.clientX-r.left)/r.width*100, y=(e.clientY-r.top)/r.height*100;
    grabbed=(Math.hypot(A.x-x,A.y-y)<=Math.hypot(B.x-x,B.y-y))?A:B;
    cal.setPointerCapture(e.pointerId); showLoupe(grabbed); e.preventDefault();
  });
  cal.addEventListener('pointermove',function(e){
    if(!grabbed) return;
    var r=stage.getBoundingClientRect();
    grabbed.x=Math.max(1,Math.min(99,(e.clientX-r.left)/r.width*100));
    grabbed.y=Math.max(1,Math.min(99,(e.clientY-r.top)/r.height*100));
    drawLine(); showLoupe(grabbed);
  });
  ['pointerup','pointercancel'].forEach(function(ev){ cal.addEventListener(ev,function(){ grabbed=null; hideLoupe(); }); });

  modal.querySelectorAll('.biw-sim__refs button').forEach(function(b){
    b.addEventListener('click',function(){
      modal.querySelectorAll('.biw-sim__refs button').forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      if(b.dataset.custom){ cmIn.focus(); cmIn.select(); } else { cmIn.value=b.dataset.cm; }
      drawLine();
    });
  });
  cmIn.addEventListener('input',drawLine);

  modal.querySelector('[data-act="valid"]').addEventListener('click',function(){
    var L=drawLine(), cm=parseFloat(cmIn.value);
    if(!L||L<20||!cm||cm<=0){ alert('Écartez un peu plus les 2 points, et vérifiez la taille indiquée.'); return; }
    var cs=containScale();
    if(!cs){ alert('Un instant, l’image finit de charger…'); return; }
    imgPxPerCm=(L/cs)/cm; decHimg=DEC_H*imgPxPerCm;
    dec.style.left='50%'; dec.style.top='50%';
    toResult(); applyDecScale(); saveWall(); track('calibrated',{cm:cm});
  });
  modal.querySelector('[data-act="recal"]').addEventListener('click',toCalib);

  /* ---------- 2b. rotation à deux doigts (tactile) ---------- */
  var pts={}, multi=false, rotLock=false, angBase=0, rotBase=0;
  function ptAngle(){ var k=Object.keys(pts); if(k.length<2) return null; var a=pts[k[0]], b=pts[k[1]]; return Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI; }
  stage.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='touch') return;
    pts[e.pointerId]={x:e.clientX,y:e.clientY};
    if(Object.keys(pts).length===2){ multi=true; rotLock=true; angBase=ptAngle(); rotBase=rot; dec.classList.remove('grab'); }
  });
  stage.addEventListener('pointermove',function(e){
    if(!(e.pointerId in pts)) return; pts[e.pointerId]={x:e.clientX,y:e.clientY};
    if(!multi) return; var a=ptAngle(); if(a===null) return;
    var d=a-angBase; if(d>180) d-=360; if(d<-180) d+=360;
    rot=Math.max(-90,Math.min(90,Math.round(rotBase+d))); if(rotIn) rotIn.value=rot; applyRot(); e.preventDefault();
  });
  function ptEnd(e){ if(!(e.pointerId in pts)) return; delete pts[e.pointerId]; var n=Object.keys(pts).length; if(multi && n<2){ multi=false; track('rotate',{deg:rot,via:'touch'}); } if(n===0) rotLock=false; }
  ['pointerup','pointercancel'].forEach(function(ev){ stage.addEventListener(ev,ptEnd); });

  /* ---------- 3. déplacement du décor ---------- */
  var drag=false, ox=0, oy=0;
  dec.addEventListener('pointerdown',function(e){
    drag=true; dec.classList.add('grab'); dec.setPointerCapture(e.pointerId);
    var r=dec.getBoundingClientRect();
    ox=e.clientX-(r.left+r.width/2); oy=e.clientY-(r.top+r.height/2); e.preventDefault();
  });
  dec.addEventListener('pointermove',function(e){
    if(!drag||rotLock) return;
    var s=stage.getBoundingClientRect();
    dec.style.left=Math.max(2,Math.min(98,((e.clientX-ox)-s.left)/s.width*100))+'%';
    dec.style.top =Math.max(2,Math.min(98,((e.clientY-oy)-s.top)/s.height*100))+'%';
  });
  ['pointerup','pointercancel'].forEach(function(ev){ dec.addEventListener(ev,function(){ drag=false; dec.classList.remove('grab'); }); });

  /* ---------- 4. partager / enregistrer l'aperçu ---------- */
  function exportComposite(cb){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih||!dec.naturalWidth){ cb(null); return; }
    try{
      var c=document.createElement('canvas'); c.width=iw; c.height=ih; var cx=c.getContext('2d');
      cx.drawImage(wall,0,0,iw,ih);
      var r=stage.getBoundingClientRect(), cs=containScale(), oxx=(r.width-iw*cs)/2, oyy=(r.height-ih*cs)/2;
      var er=dec.getBoundingClientRect();
      var cxp=(er.left+er.width/2-r.left-oxx)/cs, cyp=(er.top+er.height/2-r.top-oyy)/cs, w=dec.offsetWidth/cs, h=dec.offsetHeight/cs;
      cx.save(); cx.translate(cxp,cyp); cx.rotate(rot*Math.PI/180); cx.drawImage(dec, -w/2, -h/2, w, h); cx.restore();
      c.toBlob(function(b){ cb(b); }, 'image/jpeg', .9);
    }catch(e){ cb(null); }
  }
  function shareBlob(b){
    var f; try{ f=new File([b],'baby-in-wood-mon-mur.jpg',{type:'image/jpeg'}); }catch(e){ f=null; }
    if(f && navigator.canShare && navigator.canShare({files:[f]})){ navigator.share({files:[f], title:'Baby in Wood', text:'Le décor sur notre mur'}).catch(function(){}); return; }
    var a=document.createElement('a'); a.href=URL.createObjectURL(b); a.download='baby-in-wood-mon-mur.jpg'; document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 2000);
  }
  if(shareBtn) shareBtn.addEventListener('click',function(){
    if(!stage.classList.contains('placed')) return;
    shareBtn.disabled=true;
    exportComposite(function(b){ shareBtn.disabled=false; if(!b){ alert('Le partage n’est pas disponible sur ce navigateur.'); return; } shareBlob(b); track('share'); });
  });

  window.addEventListener('resize',function(){
    if(modal.hidden) return;
    if(stage.classList.contains('calib')) drawLine();
    if(stage.classList.contains('placed')) applyDecScale();
  });
  return {open:open};
  }
  }
  var q = window.biwSimQ || [];
  window.biwSimQ = { push: function(u){ init(u); } };
  for (var i = 0; i < q.length; i++) init(q[i]);
})();
